module.exports = __webpack_public_path__ + "static/banner-image-3-7c1cb5f674906e180725a94e7e921586.jpg";